export default __webpack_public_path__ + "static/media/checkmark.9aaab335.svg";